/**
 * "Staff" is a permission fact, never a role name (LLD §6.4, DW-27): anyone
 * holding a permission outside the customer self-service set holds an
 * AdminOnly one, and the backend makes TOTP mandatory for them (FR-IAM-10).
 *
 * The set mirrors the "Customer self-service (never AdminOnly)" block of
 * backend/src/shared/auth/permissions.go; `staff.test.ts` reads that file and
 * fails when the two drift.
 */
export const CUSTOMER_PERMISSIONS: ReadonlySet<string> = new Set([
  "account.profile:read",
  "account.profile:write",
  "account.security:manage",
  "devices.device:read",
  "devices.device:write",
  "messaging.sms:send",
  "messaging.sms:read",
  "apikeys.key:manage",
  "webhooks.subscription:manage",
  "billing.subscription:read",
  "billing.plan:purchase",
  "wallet.balance:read",
  "wallet.topup:create",
  "invoices.document:read",
  "refunds.request:create",
])

export const isStaff = (permissions: readonly string[]): boolean =>
  permissions.some((p) => !CUSTOMER_PERMISSIONS.has(p))

/** A staff member who has not enrolled TOTP may use nothing until they do (FR-DSH-PUB-08). */
export const mustEnrolTotp = (me: {
  permissions: readonly string[]
  user: { totpEnabled: boolean }
}): boolean => isStaff(me.permissions) && !me.user.totpEnabled
